import React from "react";
import ChooseCurrency from "../../../mui/choose_currency/ChooseCurrency";
import ShowContainer from "../../../mui/ShowContainer";
import CusButton from "../../../mui/custom_button/CusButton";
import IconCirclePlus from "../../../mui/JSXIcons/IconCirclePlus";
import { useDispatch } from "react-redux";
import IconCircleMinus from "../../../mui/JSXIcons/IconCircleMinus";
import { setModalBalance, setPromoCode, setWithdrawal } from "../../../../store/siteSlice";
import AvatarPopup from "./avatar_popup/AvatarPopup";
import useLoginAction from "../../../../hooks/useLoginAction";
import ChooseCurrencyFull from "../../../mui/choose_currency/ChooseCurrencyFull";
import { useAppSelector } from "../../../../store/index.ts";
import LoginButtons from "../login_buttons/LoginButtons.jsx";

export default function HeaderAuthMenu() {
  const dispatch = useDispatch();
  const { onLoginAction } = useLoginAction();
  const isMenuAbsolute = useAppSelector((state) => state.deviceSize.isMenuAbsolute);
  const isBigDesktop = useAppSelector((state) => state.deviceSize.isBigDesktop);
  const isAuth = useAppSelector((state) => state.user.isAuth);

  const isSportBookGame = useAppSelector((state) => state.games.sportBookGame);
  const isCategoryWager = useAppSelector((state) => state.games.categoryWager?.id);

  const manyNav = isSportBookGame && isCategoryWager;
  const notBigDeskAndManyNav = !isBigDesktop && manyNav;

  // объединённая с промокодами внизу
  const isFullCurrency = isMenuAbsolute || notBigDeskAndManyNav;

  return (
    <>
      <ShowContainer condition={isAuth}>
        <div className="header__auth__auth">
          {isFullCurrency ? (
            <ChooseCurrencyFull isRedirectHome />
          ) : (
            <ChooseCurrency isRedirectHome />
          )}

          <ShowContainer condition={!isFullCurrency}>
            <CusButton
              border
              icon={<IconCirclePlus />}
              className="plus"
              color="custom"
              defCusColor="gradient-blue"
              text={"Replenish"}
              onClick={() => onLoginAction(() => dispatch(setModalBalance(true)))}
            />
            <CusButton
              className="minus"
              icon={<IconCircleMinus />}
              text={"Withdraw"}
              onClick={() => onLoginAction(() => dispatch(setWithdrawal(true)))}
            />
            <CusButton
              className="promo"
              text={"Promo codes"}
              onClick={() => onLoginAction(() => dispatch(setPromoCode(true)))}
            />
          </ShowContainer>
        </div>
      </ShowContainer>
      <ShowContainer condition={isAuth} plug={<LoginButtons />}>
        <AvatarPopup />
      </ShowContainer>
    </>
  );
}
